<template>
    <v-card
        elevation="0"
        outlined
        class="pa-4"
        style="border-radius: 16px;"
    >   
        <v-row class="mx-0 mb-4 mt-0">
            <p class="tblName" style="font-size: 16px;">{{ title }}</p>
            <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        slot="activator"
                        class="botonHover"
                        icon
                        fab
                        dark
                        @click=""
                        small
                    >
                        <v-icon class="tamIconoBoton" color="#828282">more_vert</v-icon>
                    </v-btn>
                </template>
                <span>Información</span>
            </v-tooltip> -->
        </v-row>
        <v-row class="ma-0">
            <v-col xs="12" sm="12" lg="4" class="d-flex justify-center align-center">
                <img :src="imagen" style="width: 80px; height: 80px;"/>
            </v-col>
            <v-col xs="12" sm="12" lg="8">
                <div v-for="item in data" class="d-flex justify-space-between" style="width: 100%;">
                    <p :class="item.label == 'Total de contratos' ? 'valor' : 'etiqueta'">{{ item.label }}</p>
                    <p class="valor">{{ item.value }}</p>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        
        data(){
            return{

            }
        },
        props:{
            title:{
                required:true,
                default: "Titulo"
            },
            imagen:{
                required: true,
                default: "/static/modal/no-image.jpg"
            },
            data:{
                required:true,
                default: []
            }
        }
    }
</script>

<style scoped >
    .etiqueta{
        margin-bottom: 5px;
        font-size: 14px;
        color:#828282;
        font-weight: 500;
    }

    .valor{
        margin-bottom: 5px;
        font-size: 14px;
        color: #101C5A;
        font-weight: 500;
    }
</style>